import React from "react";

/**
 * A mark per research channel, so a source is recognisable before it is read.
 *
 * RESEARCH-EXPLORATION-REDESIGN revision, 2026-09-10. The Founder: "Make each
 * research source feel like a distinct intelligence channel instead of another
 * stacked form."
 *
 * SVG, not emoji — the design rules this project's skill enforces, and emoji
 * would render differently on every machine. Geometric and flat, matching the
 * Brain's own iconography.
 *
 * NO TRIANGLES. The motif was removed from Cipher deliberately, so the ad-library
 * mark is a frame rather than the usual play glyph.
 *
 * The mark is chosen by KIND, which is data from the server's catalogue — an
 * unknown kind gets the neutral mark rather than no mark, because a channel with
 * no identity is the thing this component exists to fix.
 */
const PATHS = {
  SEARCH: (
    <>
      <circle cx="7.5" cy="7.5" r="4.5" />
      <path d="M11 11l4 4" />
    </>
  ),
  SOCIAL: (
    <>
      <path d="M2.5 4.5h8a1.5 1.5 0 011.5 1.5v3a1.5 1.5 0 01-1.5 1.5H6l-2.5 2v-2H2.5A1.5 1.5 0 011 9V6a1.5 1.5 0 011.5-1.5z" />
      <path d="M14.5 7.5h1A1.5 1.5 0 0117 9v3a1.5 1.5 0 01-1.5 1.5H15v1.5l-2-1.5" />
    </>
  ),
  TRENDS: (
    <>
      <path d="M2 13l4-4 3 2.5L15 5" />
      <path d="M11.5 5H15v3.5" />
    </>
  ),
  COMPETITOR_ADS: (
    <>
      <rect x="2" y="3.5" width="14" height="11" rx="2" />
      <path d="M2 11.5h14" />
      <path d="M5 7h5" />
    </>
  ),
  PAGE_SCRAPE: (
    <>
      <path d="M4 2.5h6l4 4v9a1 1 0 01-1 1H4a1 1 0 01-1-1v-12a1 1 0 011-1z" />
      <path d="M9.5 2.5v4.5H14" />
      <path d="M6 11h6M6 13.5h4" />
    </>
  ),
};

export default function ChannelGlyph({ kind }) {
  const mark = PATHS[kind] || <circle cx="9" cy="9" r="5" />;
  return (
    <svg viewBox="0 0 18 18" width="18" height="18" aria-hidden="true"
         fill="none" stroke="currentColor" strokeWidth="1.35"
         strokeLinecap="round" strokeLinejoin="round">
      {mark}
    </svg>
  );
}
